import { updateClient, ClientDetails } from '@/api/client'
import { getActivityList } from '@/api/activityLog'

export const  StudentMixins = {
  methods:{
    async UpdateDetails (client_id = null) {
      try {
        const reqpayload = {
          updateField: {
            first_name: this.clientDetails.basic_details.first_name,
            middle_name: this.clientDetails.basic_details.middle_name,
            last_name: this.clientDetails.basic_details.last_name,
            email: this.clientDetails.basic_details.email,
            mobile: this.clientDetails.basic_details.mobile,
            address: this.clientDetails.basic_details.address,
            bio: this.clientDetails.bio,
            social_media: this.clientDetails.social_media
          }
        }
        const object1 = {
          dynamic_fields: {}
        }

        object1.dynamic_fields = this.dynamicform
        const payload = Object.assign({}, reqpayload, object1)

        const customer_id = localStorage.getItem('customer_id')
        const client_id_update = client_id ? client_id : this.$route.params.client_id
        const { data } = await updateClient(
          client_id_update,
          payload,
          customer_id
        )
        this.clientDetails = data.data.clientUser

        this.getLastActivity()

        this.$vs.notify({
          title: 'Updated',
          text: 'Student updated successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          title: 'Error',
          text: e.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    async fetchclientsAccountDetails (teacher_id) {
      try {
        const { data } = await ClientDetails(
          teacher_id,
          this.$store.getters.customerId
        )
        this.clientDetails = data.data.clientUser
        this.users = this.clientDetails.children
        const child = this.clientDetails.basic_details
        child.client_user_address = this.clientDetails.basic_details.address
        child.client_user_address.client_users_id =
          this.clientDetails.basic_details.client_users_id
        //this.fetchTag(this.platform_module_id, this.clientDetails.tags)
        const __temp = {
          address: this.clientDetails.basic_details.address,
          child
        }
        this.users.unshift(__temp)
      } catch (e) {
        //
      } finally {
        this.fetchCustomField()
      }
    },

    async getLastActivity () {
      const payload = {
        customer_id: localStorage.getItem('customer_id'),
        entity_id: this.$route.params.client_id,
        platform_module_id: 4
      }

      try {
        const response = await getActivityList(payload)
        this.new_activity = response.data.data.activity[0]
        this.$emit('studentUpdated', this.new_activity)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
